var map = {
	"./actionMenu/actionMenu": 4607,
	"./actionMenu/actionMenu.tsx": 4607,
	"./cards/cardCore": 7383,
	"./cards/cardCore.tsx": 7383,
	"./cards/cardStyles.scss": 4134,
	"./cards/cards": 2672,
	"./cards/cards.json": 2672,
	"./cards/shopCardComponent": 9458,
	"./cards/shopCardComponent.tsx": 9458,
	"./context/MeleeContextProvider": 9426,
	"./context/MeleeContextProvider.tsx": 9426,
	"./duel/duelCards": 9616,
	"./duel/duelCards.tsx": 9616,
	"./duel/duelForm": 1335,
	"./duel/duelForm.tsx": 1335,
	"./ffa/ffaBody": 4083,
	"./ffa/ffaBody.tsx": 4083,
	"./ffa/ffaCards": 4086,
	"./ffa/ffaCards.tsx": 4086,
	"./ffa/ffaHeroButton": 8915,
	"./ffa/ffaHeroButton.tsx": 8915,
	"./heroes/heroImage": 3866,
	"./heroes/heroImage.tsx": 3866,
	"./heroes/meleeHeroes": 3130,
	"./heroes/meleeHeroes.json": 3130,
	"./heroes/meleeHeroesImages/bowser.png": 2094,
	"./heroes/meleeHeroesImages/cf.png": 9767,
	"./heroes/meleeHeroesImages/dk.png": 4467,
	"./heroes/meleeHeroesImages/doppelganger.png": 2508,
	"./heroes/meleeHeroesImages/drmario.png": 620,
	"./heroes/meleeHeroesImages/falco.png": 1233,
	"./heroes/meleeHeroesImages/fox.png": 3249,
	"./heroes/meleeHeroesImages/ganon.png": 3111,
	"./heroes/meleeHeroesImages/iceclimbers.png": 8678,
	"./heroes/meleeHeroesImages/kirby.png": 4459,
	"./heroes/meleeHeroesImages/link.png": 7160,
	"./heroes/meleeHeroesImages/logo.png": 6693,
	"./heroes/meleeHeroesImages/luigi.png": 7208,
	"./heroes/meleeHeroesImages/mario.png": 8090,
	"./heroes/meleeHeroesImages/marth.png": 5086,
	"./heroes/meleeHeroesImages/mewtwo.png": 437,
	"./heroes/meleeHeroesImages/mrgame.png": 9396,
	"./heroes/meleeHeroesImages/ness.png": 1605,
	"./heroes/meleeHeroesImages/peach.png": 4433,
	"./heroes/meleeHeroesImages/pichu.png": 543,
	"./heroes/meleeHeroesImages/pika.png": 7145,
	"./heroes/meleeHeroesImages/puff.png": 2797,
	"./heroes/meleeHeroesImages/roy.png": 7988,
	"./heroes/meleeHeroesImages/samus.png": 1027,
	"./heroes/meleeHeroesImages/sheik.png": 4440,
	"./heroes/meleeHeroesImages/unpicked_icon.png": 8233,
	"./heroes/meleeHeroesImages/yoshi.png": 6600,
	"./heroes/meleeHeroesImages/younglink.png": 9078,
	"./heroes/meleeHeroesImages/zelda.png": 7250,
	"./heroes/ultimateHeroes": 8929,
	"./heroes/ultimateHeroes.json": 8929,
	"./heroes/ultimateHeroesImages/bayonetta.png": 5502,
	"./heroes/ultimateHeroesImages/bowser.png": 4085,
	"./heroes/ultimateHeroesImages/bowserjr.png": 7105,
	"./heroes/ultimateHeroesImages/cf.png": 1504,
	"./heroes/ultimateHeroesImages/cloud.png": 4612,
	"./heroes/ultimateHeroesImages/corrin.png": 1916,
	"./heroes/ultimateHeroesImages/darkpit.png": 140,
	"./heroes/ultimateHeroesImages/dedede.png": 1310,
	"./heroes/ultimateHeroesImages/diddy.png": 3585,
	"./heroes/ultimateHeroesImages/donkeykong.png": 168,
	"./heroes/ultimateHeroesImages/doppelganger.png": 5271,
	"./heroes/ultimateHeroesImages/drmario.png": 8321,
	"./heroes/ultimateHeroesImages/duckhunt.png": 3127,
	"./heroes/ultimateHeroesImages/falco.png": 708,
	"./heroes/ultimateHeroesImages/fox.png": 5840,
	"./heroes/ultimateHeroesImages/gamewatch.png": 7484,
	"./heroes/ultimateHeroesImages/ganon.png": 6618,
	"./heroes/ultimateHeroesImages/greninja.png": 3851,
	"./heroes/ultimateHeroesImages/iceclimbers.png": 9011,
	"./heroes/ultimateHeroesImages/ike.png": 9178,
	"./heroes/ultimateHeroesImages/jigglypuff.png": 7510,
	"./heroes/ultimateHeroesImages/kirby.png": 4754,
	"./heroes/ultimateHeroesImages/link.png": 3863,
	"./heroes/ultimateHeroesImages/lucario.png": 606,
	"./heroes/ultimateHeroesImages/lucas.png": 3207,
	"./heroes/ultimateHeroesImages/luciana.png": 3390,
	"./heroes/ultimateHeroesImages/luigi.png": 8693,
	"./heroes/ultimateHeroesImages/mac.png": 6590,
	"./heroes/ultimateHeroesImages/mario.png": 3955,
	"./heroes/ultimateHeroesImages/marth.png": 7715,
	"./heroes/ultimateHeroesImages/megaman.png": 1273,
	"./heroes/ultimateHeroesImages/metaknight.png": 6499,
	"./heroes/ultimateHeroesImages/mewtwo.png": 7702,
	"./heroes/ultimateHeroesImages/ness.png": 4950,
	"./heroes/ultimateHeroesImages/olimar.png": 4989,
	"./heroes/ultimateHeroesImages/pacman.png": 7451,
	"./heroes/ultimateHeroesImages/palutena.png": 7969,
	"./heroes/ultimateHeroesImages/peach.png": 2268,
	"./heroes/ultimateHeroesImages/pichu.png": 4426,
	"./heroes/ultimateHeroesImages/pika.png": 8046,
	"./heroes/ultimateHeroesImages/pit.png": 2432,
	"./heroes/ultimateHeroesImages/pokemontrainer.png": 445,
	"./heroes/ultimateHeroesImages/rob.png": 1622,
	"./heroes/ultimateHeroesImages/robin.png": 863,
	"./heroes/ultimateHeroesImages/rosalina.png": 4512,
	"./heroes/ultimateHeroesImages/roy.png": 5477,
	"./heroes/ultimateHeroesImages/ryu.png": 1471,
	"./heroes/ultimateHeroesImages/samus.png": 2546,
	"./heroes/ultimateHeroesImages/sheik.png": 8173,
	"./heroes/ultimateHeroesImages/shulk.png": 6702,
	"./heroes/ultimateHeroesImages/snake.png": 5095,
	"./heroes/ultimateHeroesImages/sonic.png": 9171,
	"./heroes/ultimateHeroesImages/toonlink.png": 9755,
	"./heroes/ultimateHeroesImages/unpicked_icon.png": 9388,
	"./heroes/ultimateHeroesImages/villager.png": 8373,
	"./heroes/ultimateHeroesImages/wario.png": 4065,
	"./heroes/ultimateHeroesImages/wiitrainer.png": 8299,
	"./heroes/ultimateHeroesImages/wolf.png": 5559,
	"./heroes/ultimateHeroesImages/yoshi.png": 2945,
	"./heroes/ultimateHeroesImages/younglink.png": 3055,
	"./heroes/ultimateHeroesImages/zelda.png": 7823,
	"./heroes/ultimateHeroesImages/zerosamus.png": 6416,
	"./heroes/useHeroes": 3444,
	"./heroes/useHeroes.tsx": 3444,
	"./modals/informationModal": 7238,
	"./modals/informationModal.tsx": 7238,
	"./modals/optionsModal": 1150,
	"./modals/optionsModal.tsx": 1150,
	"./modals/tierListModal": 2576,
	"./modals/tierListModal.tsx": 2576,
	"./preGame/meleeDashboard": 2108,
	"./preGame/meleeDashboard.tsx": 2108,
	"./preGame/playerForm": 8741,
	"./preGame/playerForm.tsx": 8741,
	"./stages/images/battlefield.jpeg": 6228,
	"./stages/images/brinstar.jpeg": 9925,
	"./stages/images/corneria.jpeg": 7637,
	"./stages/images/dreamLand.jpeg": 1820,
	"./stages/images/fd.png": 8103,
	"./stages/images/fountain.jpeg": 5650,
	"./stages/images/kongoJungle.png": 7136,
	"./stages/images/kongoJungleMelee.jpg": 7882,
	"./stages/images/mod_flatzone.png": 5121,
	"./stages/images/mod_fourside.png": 2467,
	"./stages/images/mod_greatbay.png": 3739,
	"./stages/images/mod_greengreens.png": 9710,
	"./stages/images/mod_junglejapes.png": 5236,
	"./stages/images/mod_mushroomkingdom.png": 745,
	"./stages/images/mod_mushroomkingdom2.png": 8767,
	"./stages/images/mod_mutecity.png": 9408,
	"./stages/images/mod_onett.png": 3588,
	"./stages/images/mod_peachcastle.png": 471,
	"./stages/images/mod_rainbowcruise.png": 6943,
	"./stages/images/mod_yoshiisland.png": 1769,
	"./stages/images/muteCity.jpeg": 5932,
	"./stages/images/peachCastle.jpg": 5070,
	"./stages/images/pokemon.jpeg": 7955,
	"./stages/images/yoshi.png": 7135,
	"./stages/meleeStagePacks": 9969,
	"./stages/meleeStagePacks.json": 9969,
	"./stages/stage": 9746,
	"./stages/stage.tsx": 9746,
	"./stages/ultimateStageData": 1954,
	"./stages/ultimateStageData.json": 1954,
	"./utils/cardEvents": 2339,
	"./utils/cardEvents.tsx": 2339,
	"./utils/clipboard": 9546,
	"./utils/clipboard.tsx": 9546,
	"./utils/colorUtils": 7814,
	"./utils/colorUtils.tsx": 7814,
	"./utils/drafter": 3548,
	"./utils/drafter.tsx": 3548,
	"./utils/images": 7300,
	"./utils/images.tsx": 7300,
	"./utils/playerUtils": 4294,
	"./utils/playerUtils.tsx": 4294,
	"./utils/roundHandler": 7398,
	"./utils/roundHandler.tsx": 7398,
	"./utils/stageUtils": 6623,
	"./utils/stageUtils.tsx": 6623,
	"./utils/stopwatch": 3573,
	"./utils/stopwatch.tsx": 3573
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9645;